import { animate, scroll } from 'motion';

document.addEventListener( 'DOMContentLoaded', () => {
	const timelineSection = document.querySelector( '.highlights' );
	if ( ! timelineSection ) return;

	const timelineLine = document.querySelector( '.timeline-line--hp' );
	const timelineDot = document.querySelector( '.timeline-dot--hp' );

	if ( ! timelineLine || ! timelineDot ) return;

	// Get the initial top position of the dot (should be 0)
	const dotInitialTop = 0;

	// Calculate the maximum position the dot can move to (bottom of the line minus dot height)
	const getMaxDotPosition = () => {
		const lineHeight = timelineLine.offsetHeight;
		const dotHeight = timelineDot.offsetHeight;
		return lineHeight - dotHeight;
	};

	// Create the scroll-linked animation
	scroll(
		( progress, info ) => {
			// Get viewport height
			const viewportHeight = window.innerHeight;

			// Calculate when the line enters and exits the middle of the viewport
			const lineRect = timelineLine.getBoundingClientRect();
			const lineTop = lineRect.top;
			const lineBottom = lineRect.bottom;
			const viewportMiddle = viewportHeight / 2;

			// Calculate how far the line has traveled relative to the middle of the viewport
			let dotPosition;

			// If the line hasn't reached the middle of the viewport yet
			if ( lineTop > viewportMiddle ) {
				dotPosition = dotInitialTop; // Keep dot at the top
			}
			// If the bottom of the line is above the middle of the viewport
			else if ( lineBottom < viewportMiddle ) {
				dotPosition = getMaxDotPosition(); // Keep dot at the bottom
			}
			// Line is passing through the middle of viewport - calculate position
			else {
				const totalLineTravel = lineRect.height;
				const lineProgress =
					( viewportMiddle - lineTop ) / totalLineTravel;
				dotPosition = lineProgress * getMaxDotPosition();
			}

			// Update the dot position
			timelineDot.style.top = `${ dotPosition }px`;
		},
		{
			target: timelineSection,
		}
	);
} );
